/**
 * @generated SignedSource<<a8077455fff89d3a5b4e7ecfdbe7e37d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WTCSSelectRoutineQuery$variables = {
  teamId: string;
};
export type WTCSSelectRoutineQuery$data = {
  readonly store: {
    readonly team: {
      readonly id: string;
      readonly routines: ReadonlyArray<{
        readonly activeSections: ReadonlyArray<{
          readonly id: string;
          readonly lastVersion: {
            readonly tasks: ReadonlyArray<{
              readonly id: string;
              readonly title: string;
            }>;
          };
        }>;
        readonly id: string;
        readonly title: string;
      }> | null;
      readonly " $fragmentSpreads": FragmentRefs<"ListSectionHeaderTeam_Team">;
    } | null;
  };
};
export type WTCSSelectRoutineQuery = {
  response: WTCSSelectRoutineQuery$data;
  variables: WTCSSelectRoutineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "includeOrg",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "onlyChecklists",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "STANDARD"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WTCSSelectRoutineQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ListSectionHeaderTeam_Team"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routines",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "activeSections",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSectionVersion",
                        "kind": "LinkedField",
                        "name": "lastVersion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "tasks",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "routines(includeOrg:true,onlyChecklists:true,type:\"STANDARD\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WTCSSelectRoutineQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routines",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "activeSections",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSectionVersion",
                        "kind": "LinkedField",
                        "name": "lastVersion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "tasks",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "routines(includeOrg:true,onlyChecklists:true,type:\"STANDARD\")"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bbf417634232bd6f331fe0872ad2392",
    "id": null,
    "metadata": {},
    "name": "WTCSSelectRoutineQuery",
    "operationKind": "query",
    "text": "query WTCSSelectRoutineQuery(\n  $teamId: ID!\n) {\n  store {\n    team(id: $teamId) {\n      id\n      ...ListSectionHeaderTeam_Team\n      routines(includeOrg: true, type: STANDARD, onlyChecklists: true) {\n        id\n        title\n        activeSections {\n          id\n          lastVersion {\n            tasks {\n              __typename\n              id\n              title\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ListSectionHeaderTeam_Team on Team {\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "fda1e5f1c3c3ce5570a605caeb80250a";

export default node;
